import { z } from 'zod';

import { meetsPasswordStrength, passwordsMatch } from '@src/domains/customers';
import type { Translate } from '@src/i18n/useTranslate';

const requiredStringField = (t: Translate['i18n']) => {
  const requiredMessage = t('checkout_auth_required_field');

  return z.string({ required_error: requiredMessage }).min(1, requiredMessage);
};

export const recoveryPasswordFieldSchema = (t: Translate['i18n']) =>
  requiredStringField(t).refine(meetsPasswordStrength, t('checkout_auth_password_strength'));

export const recoveryNewPasswordSchema = (t: Translate['i18n']) =>
  z
    .object({
      password: recoveryPasswordFieldSchema(t),
      passwordConfirmation: requiredStringField(t),
    })
    .superRefine(({ password, passwordConfirmation }, ctx) => {
      if (passwordsMatch(password, passwordConfirmation)) return;

      ctx.addIssue({
        code: 'custom',
        message: t('checkout_auth_password_mismatch'),
        path: ['passwordConfirmation'],
      });
    });

export type RecoveryNewPasswordFormValues = z.infer<ReturnType<typeof recoveryNewPasswordSchema>>;
